var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-row flex-wrap w-full h-full py-52 sm:px-48"},[_c('div',{staticClass:"loader m-auto"}),_c('div',{staticClass:"flex flex-row flex-wrap h-auto w-full m-auto justify-center mt-space-m"},[_c('p',{staticClass:"m-auto block mt-6 font-medium dark:text-white"},[_vm._v(" Please wait while we gather your results... ")])])])])
}]

export { render, staticRenderFns }